module.exports = __webpack_public_path__ + "static/front/img/company.450bdc5a.svg";